import { trpc } from "@blis/trpc/react";

import { FieldError, Label } from "@/components/ui/field";
import {
  Select,
  SelectItem,
  SelectList,
  SelectTrigger,
} from "@/components/ui/select";

export function ReceivingOrgSelect({
  value,
  onChange,
  label,
  isInvalid,
  error,
}: {
  value: number;
  onChange: (value: number) => void;
  label?: React.ReactNode;
  isInvalid?: boolean;
  error?: string;
}) {
  const { data } = trpc.orgs.primaryLabs.useQuery();
  const options = data || [];

  return (
    <Select
      aria-label="Receiving lab"
      className="w-fit max-w-full"
      selectedKey={Number.isNaN(value) ? null : value}
      onSelectionChange={(key) => {
        onChange(key as number);
      }}
      placeholder="Select..."
      isInvalid={isInvalid}
      validationBehavior="aria"
    >
      {label && <Label>{label}</Label>}
      <SelectTrigger />
      <SelectList items={options}>
        {(item) => {
          return (
            <SelectItem id={item.id} textValue={item.name}>
              {item.name}
            </SelectItem>
          );
        }}
      </SelectList>
      <FieldError>{error}</FieldError>
    </Select>
  );
}
